import { dbPost } from '../../apis/commonApi';

class BasicSurveySecondController {
  constructor(
    { store, updateStore },
    { pageParam, setPageParam },
    { mode, setMode },
    { rskList, setRskList },
    modalService,
    validateService,
    navigate
  ) {
    this.store = store;
    this.updateStore = updateStore;
    this.pageParam = pageParam;
    this.setPageParam = setPageParam;
    this.mode = mode;
    this.setMode = setMode;
    this.rskList = rskList;
    this.setRskList = setRskList;
    this.modalService = modalService;
    this.validateService = validateService;
    this.navigate = navigate;
  }

  async fnSearch() {
    const url = '/aia/analysis//bsc/second/list.do';

    let response;

    try {
      response = await dbPost(url, this.pageParam);

      if (response instanceof Error) {
        this.modalService.errorAlert('처리중 에러가 발생하였습니다.', () => {});
      } else {
        let temp = [...response.rskList];
        if (response.mode === 'new') {
          for (let i = 0; i < temp.length; i++) {
            const item = temp[i];
            item.bscExmnId = this.pageParam.bscExmnId;
          }
        }

        this.setMode(response.mode);
        this.setRskList(temp);

        if (temp.length === 0) {
          if (response.mode === 'new') {
            this.modalService.confirmAlert(
              {
                msg: '위험요인이 높은 항목이 없습니다. 조사를 완료하시겠습니까?',
              },
              [
                () => {
                  this.fnSave();
                },
                () => {},
              ]
            );
          } else {
            this.modalService.successAlert(
              '위험요인이 높은 항목이 존재하지 않고, 완료된 조사입니다. 페이지를 이동합니다.',
              () => {
                this.navigate('/ai/surveyList', {
                  state: {},
                });
              }
            );
          }
        }
      }
    } catch (e) {
      this.modalService.errorAlert('처리중 에러가 발생하였습니다.', () => {});
    }
  }

  async modifyList(list) {
    const groupByThmb = list.reduce((acc, cur) => {
      if (!acc[cur.thmb]) {
        acc[cur.thmb] = {
          thmb: cur.thmb,
          bscExmnId: cur.bscExmnId,
          children: [],
        };
      }

      Array.from({ length: 5 }, (_, i) => i + 1).forEach(num => {
        acc[cur.thmb].children.push({
          rskId: cur.rskId,
          frameNo: cur.frameNo,
          anlsTrprLbl: cur.anlsTrprLbl,
          [`rskVrbl0${num}`]: cur[`rskVrbl0${num}`],
          [`rskVrblCs0${num}`]: cur[`rskVrblCs0${num}`],
        });
      });

      return acc;
    }, {});

    const result = Object.values(groupByThmb);

    return result;
  }

  async fnGoToPrevPage() {
    this.navigate('/ai/basicSurveyFirst', {
      state: {
        ...this.pageParam,
      },
    });
  }

  async fnChangeRisk(rskId, aiaRsltId, frameNo, anlsTrprLbl, model, value) {
    let temp = [...this.rskList];

    if (this.mode === 'new') {
      for (let i = 0; i < temp.length; i++) {
        if (
          temp[i].aiaRsltId === aiaRsltId &&
          temp[i].frameNo === frameNo &&
          temp[i].anlsTrprLbl === anlsTrprLbl
        ) {
          temp[i][model] = value;
        }
      }
    } else {
      for (let i = 0; i < temp.length; i++) {
        if (temp[i].rskId === rskId) {
          temp[i][model] = value;
        }
      }
    }

    this.setRskList(temp);
  }

  async fnSave() {
    const url = '/aia/analysis/bsc/second/save.do';
    const param = {
      mode: this.mode,
      rskList: this.rskList,
      bscExmnId: this.pageParam?.bscExmnId,
    };

    let response;

    try {
      response = await dbPost(url, param);

      if (response instanceof Error) {
        this.modalService.errorAlert('처리중 에러가 발생하였습니다.', () => {});
      } else {
        this.modalService.successAlert('저장이 완료되었습니다.', () => {});
        this.setRskList([]);
        this.fnSearch();
      }
    } catch (e) {
      this.modalService.errorAlert('처리중 에러가 발생하였습니다.', () => {});
    }
  }
}

export default BasicSurveySecondController;
